// extracted by mini-css-extract-plugin
export default {"main":"I2mAm","disabledPlus":"OUaCW"};